<template>
  <div class="big">
    <div class="page_title">项目列表</div>
    <div style="padding:20px;border-radius:5px;">
      <div class="container">
        <div>
          <el-menu
            :default-active="activeIndex"
            class="el-menu-demo"
            mode="horizontal"
            @select="handleSelect"
          >
            <el-menu-item
              index="1"
              style="font-size:16px"
            >全部</el-menu-item>
            <el-menu-item
              index="2"
              style="font-size:16px"
            >体检项目</el-menu-item>
          </el-menu>
        </div>
        <div class="box">
          <div class="component">
            <component :is="currentComponent" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import AllPj from './AllPj';
import ExaminationPj from './ExaminationPj';

export default {
  data() {
    return {
      activeIndex: '2',
      active: '2'
    };
  },
  computed: {
    currentComponent() {
      switch (this.active) {
        case '1':
          return AllPj;
        case '2':
          return ExaminationPj;
        default:
          return AllPj;
      }
    }
  },
  methods: {
    handleSelect(key, keyPath) {
      this.active = key;
    }
  }
};
</script>
<style lang="scss" scoped>
.container {
  box-sizing: border-box;
  background-color: #ffffff;
  min-height: calc(100vh - 140px);
}

.box {
  width: 100%;
  box-sizing: border-box;

  .component {
    width: 100%;
    box-sizing: border-box;
  }
}
</style>
